import { Component } from '@angular/core';
import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CouponsComponent } from './dashboard/coupons/coupons.component';
import { FormCouponComponent } from './dashboard/coupons/form-coupon/form-coupon.component';
import { BulkCouponEditComponent } from './dashboard/coupons/bulk-coupon-edit/bulk-coupon-edit.component';
import { PartnerCouponsComponent } from './dashboard/partner-coupons/partner-coupons.component';
import { UserInfoComponent } from './dashboard/user-info/user-info.component';
import {
  financeAccessGuard,
  isAuthenticatedGuard,
  staffOnlyGuard,
} from './guards/is-authenticated.guard';
import { UserDetailComponent } from './dashboard/user-detail/user-detail.component';
import { TransactionCreateComponent } from './dashboard/transactions/transaction-create/transaction-create.component';
import { BattleListComponent } from './dashboard/battle-list/battle-list.component';
import { BattleResultChangeComponent } from './dashboard/battle-result-change/battle-result-change.component';
import { ResultsComponent } from './dashboard/results/results.component';
import { LeaguesComponent } from './dashboard/leagues/leagues.component';
import { LeagueFormComponent } from './dashboard/leagues/league-form/league-form.component';
import { LeagueDetailComponent } from './dashboard/leagues/league-detail/league-detail.component';
import { SeasonsComponent } from './dashboard/seasons/seasons.component';
import { SeasonWizardComponent } from './dashboard/seasons/season-wizard/season-wizard.component';
import { SeasonDetailComponent } from './dashboard/seasons/season-detail/season-detail.component';
import { SeasonRankingComponent } from './dashboard/seasons/season-ranking/season-ranking.component';
import { TransactionsComponent } from './dashboard/transactions/transactions.component';
import { TransactionDetailComponent } from './dashboard/transactions/transaction-detail/transaction-detail.component';
import { UserFunnelComponent } from './dashboard/user-funnel/user-funnel.component';
import { FinancialComponent } from './dashboard/financial/financial.component';
import { FinancialDetailsComponent } from './dashboard/financial-details/financial-details.component';
import { FinancialFlowsComponent } from './dashboard/financial-flows/financial-flows.component';
import { FinancialAcquisitionComponent } from './dashboard/financial-acquisition/financial-acquisition.component';
import { CampaignsComponent } from './dashboard/campaigns/campaigns.component';
import { CampaignDetailsComponent } from './dashboard/campaign-details/campaign-details.component';
import { AnnouncementsComponent } from './dashboard/announcements/announcements.component';
import { TrustedRequestsComponent } from './dashboard/trusted-requests/trusted-requests.component';
import { MissionsComponent } from './dashboard/missions/missions.component';
import { MissionDetailComponent } from './dashboard/missions/mission-detail/mission-detail.component';

export const routes: Routes = [
  { path: '', pathMatch: 'prefix', redirectTo: 'login' },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [isAuthenticatedGuard],
    children: [
      { path: 'cupons', component: CouponsComponent, canActivate: [staffOnlyGuard] },
      { path: 'cupons/novo', component: FormCouponComponent, canActivate: [staffOnlyGuard] },
      { path: 'cupons/editar-multiplos', component: BulkCouponEditComponent, canActivate: [staffOnlyGuard] },
      { path: 'cupons/:id/editar', component: FormCouponComponent, canActivate: [staffOnlyGuard] },
      { path: 'novo-cupom', redirectTo: 'cupons/novo', pathMatch: 'full' },
      { path: 'cupom-parceiro', component: PartnerCouponsComponent },
      { path: 'users-info', component: UserInfoComponent },
      { path: 'users-info/:id', component: UserDetailComponent },
      { path: 'trusted-requests', component: TrustedRequestsComponent, canActivate: [staffOnlyGuard] },
      { path: 'user-funnel', component: UserFunnelComponent },
      {
        path: 'campaigns',
        component: CampaignsComponent
      },
      {
        path: 'campaigns/:id',
        component: CampaignDetailsComponent
      },
      { path: 'missions', component: MissionsComponent },
      { path: 'missions/:id', component: MissionDetailComponent },
      {
        path: 'announcements',
        component: AnnouncementsComponent
      },
      {
        path: 'transactions/nova',
        component: TransactionCreateComponent,
        canActivate: [isAuthenticatedGuard, financeAccessGuard, staffOnlyGuard],
      },
      {
        path: 'transactions/:id',
        component: TransactionDetailComponent,
        canActivate: [financeAccessGuard],
      },
      {
        path: 'transactions',
        component: TransactionsComponent,
        canActivate: [financeAccessGuard],
      },
      { path: 'transacao', redirectTo: 'transactions/nova', pathMatch: 'full' },
      { path: 'battle-list', component: BattleListComponent },
      { path: 'battle-list-finished', component: BattleListComponent },
      { path: 'battle-list-finished/:publicId/result', component: BattleResultChangeComponent, canActivate: [staffOnlyGuard] },
      { path: 'resultados', component: ResultsComponent },
      { path: 'financial', redirectTo: 'financial/resumo', pathMatch: 'full' },
      { path: 'financial/resumo', component: FinancialComponent },
      { path: 'financial/detalhes', component: FinancialDetailsComponent },
      { path: 'financial/entradas-saidas', component: FinancialFlowsComponent },
      { path: 'financial/aquisicao', component: FinancialAcquisitionComponent },
      { path: 'ligas', component: LeaguesComponent },
      { path: 'ligas/nova', component: LeagueFormComponent },
      { path: 'ligas/:id', component: LeagueDetailComponent },
      { path: 'ligas/:id/editar', component: LeagueFormComponent },
      { path: 'temporadas', component: SeasonsComponent },
      { path: 'temporadas/nova', component: SeasonWizardComponent },
      { path: 'temporadas/:id/ranking', component: SeasonRankingComponent },
      { path: 'temporadas/:id', component: SeasonDetailComponent },
    ],
  },
];
